<!-- sidebar w-48 -->
<div class="hidden md:flex flex-col w-52 bg-white h-full sidebar shadow-lg">
  <div class="flex items-center h-16 mt-2 pl-5">
    <img width="100px" src="logo.png" />
  </div>

  <div class="flex flex-col flex-1 overflow-y-auto">
    <nav class="flex-1 px-2 py-4">

      @for (item of sidebarItems; track $index) {

        <!-- Item WITH children: acts as an accordion trigger -->
        @if (hasChildren(item)) {
          <div class="my-2">
            <button
              type="button"
              (click)="toggleExpand(item)"
              class="w-full flex items-center px-3 py-3 rounded-md group font-medium
                     hover:bg-primary-50 hover:text-primary-900
                     transition-colors duration-150"
            >
              <span class="material-symbols-outlined mr-3 align-middle">
                {{ item.icon }}
              </span>

              <span class="flex-1 text-left">{{ item.label }}</span>

              <!-- Chevron icon — rotates when expanded -->
              <span
                class="material-symbols-outlined text-base transition-transform duration-300"
                [class.rotate-180]="isExpanded(item)"
              >
                expand_more
              </span>
            </button>

            <!-- Children list with CSS height animation -->
            <div
              class="children-wrapper overflow-hidden"
              [class.children-expanded]="isExpanded(item)"
            >
              <div class="children-inner pt-1 pb-1">
                @for (child of item.children; track $index) {
                  <a
                    [routerLink]="[child.route]"
                    [class.child-active]="isActive(child.route)"
                    class="flex items-center pl-6 pr-4 py-2 my-1 rounded-md
                           font-medium text-sm
                           hover:bg-primary-50 hover:text-primary-900
                           transition-colors duration-150"
                  >
                    <span class="material-symbols-outlined text-base mr-3 align-middle">
                      {{ child.icon }}
                    </span>
                    {{ child.label }}
                  </a>
                }
              </div>
            </div>
          </div>

        } @else {

          <!-- Regular item: navigates directly -->
          <a
            [routerLink]="[item.route]"
            [class.active-link]="isActive(item.route)"
            class="flex items-center px-3 py-3 my-2 rounded-md group
                   hover:bg-primary-50 hover:text-primary-900 font-medium
                   transition-colors duration-150"
          >
            <span class="material-symbols-outlined mr-3 align-middle">
              {{ item.icon }}
            </span>
            {{ item.label }}
          </a>

        }
      }

    </nav>
  </div>

  <!-- User menu button -->
  <button
    class="flex px-2 items-center hover:bg-gray-100 px-4 py-2 rounded-md cursor-pointer"
    [matMenuTriggerFor]="menu"
  >
    <div>
      <div role="button" class="rounded-full bg-primary-50 px-3 py-2 w-fit">
        JD
      </div>
    </div>
    <div class="flex flex-col ml-3">
      <span class="font-medium capitalize">{{ auth.fullName }}</span>
      <span class="capitalize mt-2">{{ auth.organisationName }}</span>
    </div>
  </button>

  <mat-menu #menu="matMenu" class="bg-white">
    <div class="flex flex-col ml-3">
      <span class="font-medium capitalize">{{ auth.fullName }}</span>
      <span class="capitalize mt-2 text-xs font-normal">{{ auth.organisationName }}</span>
    </div>
    <mat-divider></mat-divider>

    <button mat-menu-item>
      <span class="material-symbols-outlined mr-3 align-middle">settings</span>
      <span>Paramètres personnels</span>
    </button>

    <button mat-menu-item (click)="logOut()">
      <span class="material-symbols-outlined mr-3 align-middle">logout</span>
      <span>Me déconnecter</span>
    </button>
  </mat-menu>
</div>